export default {
  labels: {
    today: 'Hoy',
    pickup_time: 'Hora de recogida',
    delivery_time: 'Hora de entrega',
  },
};
